import {MAX_SHARE_MESSAGE_LENGTH, MAX_SHARE_RECIPIENTS} from "./shareLimits";

/**
 * Explains why the server refused a share (DE-1843), from the HTTP status the fetch layer rejects with.
 * Returns null for any other failure (500, 'retry', network errors) so the caller shows its generic text.
 *
 * @param {Function} t - The caller's translation function.
 * @param {*} status - The rejection value of the request.
 * @returns {string|null}
 */
export const shareRefusalMessage = (t, status) => {
    switch (Number(status)) {
        case 403:
            return t("shareErrorForbidden", "Du har ikke tilgang til å dele dette.");
        case 400:
            return t(
                "shareErrorLimits",
                `Delingen er over grensen: høyst ${MAX_SHARE_RECIPIENTS} mottagere og ${MAX_SHARE_MESSAGE_LENGTH} tegn i meldingen.`,
                {maxRecipients: MAX_SHARE_RECIPIENTS, maxLength: MAX_SHARE_MESSAGE_LENGTH}
            );
        case 404:
            return t("shareErrorNotFound", "Objektet finnes ikke, eller er utilgjengelig for deg.");
        default:
            return null;
    }
};
